const ANDROID_PACKAGE_NAME = 'app.wereader';
const PLAY_STORE_URL_PATTERN = /^(market:\/\/|https?:\/\/play\.google\.com\/)/i;
const ANDROID_PROMO_UTM_SOURCE = 'wereader_web';
const ANDROID_PROMO_UTM_MEDIUM = 'owned_web';
const ANDROID_PROMO_UTM_CAMPAIGN = 'android_app_promo';

export const DEFAULT_ANDROID_PLAY_STORE_INTENT_URL = `market://details?id=${ANDROID_PACKAGE_NAME}`;
export const DEFAULT_ANDROID_PLAY_STORE_WEB_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`;

export const buildAndroidPlayStorePromotionUrl = (
  placement: string,
  options?: { intentUrl?: boolean },
): string => {
  const campaignParams = new URLSearchParams({
    utm_source: ANDROID_PROMO_UTM_SOURCE,
    utm_medium: ANDROID_PROMO_UTM_MEDIUM,
    utm_campaign: ANDROID_PROMO_UTM_CAMPAIGN,
    utm_content: placement,
  });
  const url = new URL(options?.intentUrl ? DEFAULT_ANDROID_PLAY_STORE_INTENT_URL : DEFAULT_ANDROID_PLAY_STORE_WEB_URL);

  campaignParams.forEach((value, key) => {
    url.searchParams.set(key, value);
  });
  url.searchParams.set('referrer', campaignParams.toString());

  return url.toString();
};

export const normalizeAndroidPlayStoreUrl = (storeUrl?: string | null): string | null => {
  if (!storeUrl) {
    return null;
  }

  const trimmedStoreUrl = storeUrl.trim();
  if (!trimmedStoreUrl || !PLAY_STORE_URL_PATTERN.test(trimmedStoreUrl)) {
    return null;
  }

  return trimmedStoreUrl;
};

export const getAndroidPlayStoreUpdateUrls = (storeUrl?: string | null): string[] => {
  const candidateUrls = [
    DEFAULT_ANDROID_PLAY_STORE_INTENT_URL,
    normalizeAndroidPlayStoreUrl(storeUrl),
    DEFAULT_ANDROID_PLAY_STORE_WEB_URL,
  ].filter((value): value is string => Boolean(value));

  return [...new Set(candidateUrls)];
};
